import { fetchQuery, graphql } from 'relay-runtime';

import { getAnonymousEnvironment, getOrganizationSlug } from './relay.js';
import { type organizationSettingsQuery } from './__generated__/organizationSettingsQuery.graphql.js';

/**
 * Get organization settings such as currency
 */
export async function getOrganizationSettings() {
  const slug = getOrganizationSlug();

  if (slug == null) {
    return null;
  }

  return fetchQuery<organizationSettingsQuery>(
    getAnonymousEnvironment(),
    graphql`
      query organizationSettingsQuery($slug: String!) {
        organization(slug: $slug) {
          currency
        }
      }
    `,
    { slug },
  ).toPromise();
}
